import React from 'react';
import { bool, shape, string } from 'prop-types';

const Chemicals = ({
  className = '',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 13.4004C12.8284 13.4004 13.5 14.072 13.5 14.9004C13.4997 15.7286 12.8283 16.4004 12 16.4004C11.1717 16.4004 10.5003 15.7286 10.5 14.9004C10.5 14.072 11.1716 13.4004 12 13.4004Z" fill="currentColor" />
    <path d="M10 10.4004C10.8284 10.4004 11.5 11.072 11.5 11.9004C11.4997 12.7286 10.8283 13.4004 10 13.4004C9.17174 13.4004 8.50026 12.7286 8.5 11.9004C8.5 11.072 9.17157 10.4004 10 10.4004Z" fill="currentColor" />
    <path d="M14 10.4004C14.8284 10.4004 15.5 11.072 15.5 11.9004C15.4997 12.7286 14.8283 13.4004 14 13.4004C13.1717 13.4004 12.5003 12.7286 12.5 11.9004C12.5 11.072 13.1716 10.4004 14 10.4004Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M20 5H19V23H5V5H4V3H7V1H11V3H20V5ZM7 21H17V19H7V21ZM7 17H17V9H7V17ZM7 7H17V5H7V7Z" fill="currentColor" />
  </svg>
);

Chemicals.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Chemicals;
